import PageLayout from 'pages/InstructorViewAssignment/PageLayout';
import PageProvider from 'pages/InstructorViewAssignment/PageProvider';

const InstructorViewAssignmentPage = ({ ...props }) => {
    return (
        <PageProvider {...props}>
            <PageLayout {...props} />
        </PageProvider>
    );
};

export default InstructorViewAssignmentPage;
